import { useState, useEffect, useContext } from 'react';
import { View, StyleSheet, Text, TouchableOpacity, Dimensions } from 'react-native';
import { useHRAdminEmployees } from '../../../../hooks/useHRAdminEmployees';
import Modal from "react-native-modal";
import { useTranslation } from 'react-i18next';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import HRAdminEditEmployeeScreen from './HRAdminEditEmployeeScreen';
import HRAdminEmployeeTimeSchemes from './HRAdminEmployeeTimeSchemes';
import { useTheme } from '@react-navigation/native';
import HRAdminUserRoles from './HRAdminUserRoles';
import HRAdminEmplAuthorizations from './HRAdminEmplAuthorizations';
import HRAdminReportsTo from './HRAdminReportsTo';
//import HRAdminWorkflows from './HRAdminWorkflows';
import HRAdminEmplWorkflows from '../HRAdminEmplWorkflows';
import HRAdminAuthCompanies from './HRAdminAuthCompanies';
import { HRAdminCompanyContext } from '../../../../context/HRAdminCompanyContext';

const HRAdminEmployeeWizard = (props) => {

    //#region Variables
    const [showModal, setShowModal] = useState(false);
    const [lastPressed, setLastPressed] = useState(0);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const { setSelectedEmployee } = useContext(HRAdminCompanyContext);
    // for debugging purposes: 
    // useEffect(() => {
    //     setLastPressed(1);
    //     setEmployee({
    //         employeeID: '123test',
    //         name: 'test111',
    //         username: 'test111',
    //         company: 'DT',
    //         branch: 'LIM',
    //         location: 'LIMG1',
    //         buildingFloor: null
    //     });
    //     setSelectedBranch('LIM');
    //     setSelectedLocation('LIMG1');
    //     setSelectedFloor(null)
    // }, [])



    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [employee, setEmployee] = useState({});
    const [openModal, setOpenModal] = useState(true);
    const { width, height } = Dimensions.get('window');
    const { getEmployeeWizard } = useHRAdminEmployees();
    const { colors } = useTheme();
    const styles = makeStyles(colors, width, height);
    const { t } = useTranslation();
    //#endregion

    //#region Use Effects
    // // for debugging purposes: 
    // useEffect(() => {
    //     setLastPressed(7);
    //     setEmployee({
    //         employeeID: '1001007',
    //         name: 'Andreas Andreou - F',
    //         username: 'aandreou06',
    //         company: 'dt',
    //         branch: 'RADC',
    //         location: 'NICT',
    //         floor: null
    //     });
    //     setSelectedBranch(employee.branch);
    //     setSelectedLocation(employee.location);
    //     setSelectedFloor(employee.buildingFloor)
    //     showModalHandler();
    //     setOpenModal(true);
    // }, [])

    useEffect(() => {
        setSelectedEmployee(undefined);
        let type = 'Employee Wizard';
        setIsLoading(true);
        getEmployeeWizard({ type }).then((res) => {
            let options = res?.data;
            setOptions(options);
            if (lastPressed === 0) {
                showModalHandler();
            }
            setIsLoading(false);
        });
    }, []);
    //#endregion

    const showModalHandler = () => {
        setShowModal(true);
    };

    const hideModalHandler = () => {
        setShowModal(false);
    };

    function cancelModalHandler() {
        setShowModal(false);
        props.pressedOnSelectEmployee()
    }
    const handleOptionPress = (index) => {
        setLastPressed(index + 1);
        hideModalHandler();
        setOpenModal(false);
    };

    const changeStep = (employee) => {
        if (lastPressed === 1) {
            setEmployee({
                employeeID: employee.employeeID,
                name: employee.name,
                username: employee.username,
                company: employee.company,
                branch: employee.branch,
                location: employee.location,
                floor: employee.buildingFloor
            });
            setSelectedBranch(employee.branch);
            setSelectedLocation(employee.location);
            setSelectedFloor(employee.buildingFloor)
        }
        showModalHandler();
        setOpenModal(true);
    }

    const renderStepComponent = () => {
        switch (lastPressed) {
            case 1:
                return <HRAdminEditEmployeeScreen isEdit={false} changeStep={changeStep} setEmployee={setEmployee} pressedOnSelectEmployee={props.pressedOnSelectEmployee} />;
            // case 2:
            //     return <HRAdminEmployeeTimeSchemes
            //         onSuccess={changeStep}
            //         employee={employee}
            //         setSelectedBranch={setSelectedBranch}
            //         setSelectedLocation={setSelectedLocation}
            //         setSelectedFloor={setSelectedFloor}
            //         selectedBranch={selectedBranch}
            //         selectedLocation={selectedLocation}
            //         selectedFloor={selectedFloor}
            //     />;
            case 2:
                return <HRAdminUserRoles
                    changeStep={changeStep}
                    employee={employee}
                />;
            case 3:
                return <HRAdminEmplAuthorizations
                    changeStep={changeStep}
                    employee={employee}
                />;
            case 4:
                return <HRAdminAuthCompanies
                    changeStep={changeStep}
                    employee={employee}
                />;
            case 5:
                changeStep()
            case 6:
                return <HRAdminReportsTo
                    changeStep={changeStep}
                    employee={employee}
                />;
            case 7:
                return <HRAdminEmplWorkflows
                    changeStep={() => {
                        setSelectedEmployee(employee);
                        props.pressedOnSelectEmployee();
                    }}
                    selectedEmployee={employee}
                    selectedCompany={{ code: employee.company }}
                />;
            default:
                return <CustomLabel
                    value='COMING SOON!'
                    type='COMING_SOON'
                />
        }
    };

    if (isLoading) return null;

    return (
        <>
            {openModal ? (
                <View style={styles.container}>
                    <Modal
                        isVisible={showModal}
                        onBackdropPress={cancelModalHandler}
                        onBackButtonPress={cancelModalHandler}
                        onRequestClose={cancelModalHandler}
                        style={styles.modal}
                        hasBackdrop={true}
                        backdropColor={colors.background_approved}
                        backdropOpacity={0.9}
                        width={width}
                        height={height}
                    >
                        <View style={[styles.modalContent, { width: width / 2 }]}>
                            <Text style={styles.title}>{t('common:emplWizard')}</Text>
                            <View style={styles.optionsContainer}>
                                {options.map((option, index) => (
                                    <TouchableOpacity
                                        key={index}
                                        style={[
                                            styles.optionButton,
                                            index !== lastPressed && styles.disabledButton,
                                        ]}
                                        onPress={() => handleOptionPress(index)}
                                        disabled={index !== lastPressed}
                                    >
                                        <CustomLabel
                                            value={`${option.step}: ${option.description}`}
                                            type='AVAILABLEUSED_SECONDARY'
                                        />
                                    </TouchableOpacity>
                                ))}
                            </View>
                        </View>
                    </Modal>
                </View>
            ) : (
                <SafeAreaView style={styles.mainView}>
                    {renderStepComponent()}
                </SafeAreaView>
            )}
        </>
    );
};


const makeStyles = (colors, width, height) => StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        backgroundColor: '#fff',
        borderRadius: 10,
        padding: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 20,
    },
    optionsContainer: {
        width: '100%',
        alignItems: 'center',
    },
    optionButton: {
        backgroundColor: colors.background_approved,
        padding: 10,
        marginVertical: 5,
        borderRadius: 5,
        width: '80%',
        alignItems: 'center',
    },
    disabledButton: {
        backgroundColor: '#A9A9A9',
    },
    optionText: {
        color: '#fff',
        fontSize: 16,
    },
    mainView: {
        flex: 1,
        marginBottom: '3%',
        height: '100%',
    },
});

export default HRAdminEmployeeWizard;